import classNames from 'classnames';
import { HTMLRenderer } from 'common/html-renderer.js';
import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';
import { moduleHasTitle } from 'utilities/layout.js';

export interface IHTMLRendererModuleProps {
  /** We added string arrays here on request as long lines pf html can be a nightmare to manage */
  content?: string | Array<string>;
}

export const HTMLModule = ({ isDrawer, modulePath, config }: IModule<IHTMLRendererModuleProps & IMapSlotClose>) => {
  const { content, onModuleClose } = config;

  return (
    <Tile dataModule="richtext-html html-renderer" config={config}>
      <div className="Tile-body">
        <TileBodyHeaderV2 isDrawer={isDrawer} modulePath={modulePath} config={config} onModuleClose={onModuleClose} />
        <HTMLRenderer
          classes={classNames({ 'u-mT-responsive': moduleHasTitle({ isDrawer, config }) })}
          content={content}
        />
      </div>
    </Tile>
  );
};
